import { render } from "./SideBarDesktopSettings.vue?vue&type=template&id=5924a636"
import script from "./SideBarDesktopSettings.vue?vue&type=script&lang=js"
export * from "./SideBarDesktopSettings.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__